export default "__VITE_ASSET__CAFAdQmJ__"